export default __webpack_public_path__ + "static/media/pagination_right_arrow.0a9e9ef7.svg";